import { render } from "./PricingAndMarginPageV2.vue?vue&type=template&id=0f1d824a&scoped=true"
import script from "./PricingAndMarginPageV2.vue?vue&type=script&lang=js"
export * from "./PricingAndMarginPageV2.vue?vue&type=script&lang=js"

import "./PricingAndMarginPageV2.vue?vue&type=style&index=0&id=0f1d824a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1d824a"]])

export default __exports__